<template>
	<b-container fluid>
		<b-row>
			<b-col>
				<card>
					<OmittedStopsReportTable></OmittedStopsReportTable>
				</card>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import OmittedStopsReportTable from '@/components/Report/OmittedStopsReportTable.vue';

export default {
	name: 'OmittedStopsReport',
	components: {
		OmittedStopsReportTable
	}
};
</script>